/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

function ContactForm({ homePage = false }) {
  return (
    <>
      <div className="contact-information contact-themed-bg">
        {/* Decorative gradient orbs */}
        <div className="contact-bg-orb contact-bg-orb--blue" />
        <div className="contact-bg-orb contact-bg-orb--purple" />
        <div className="contact-bg-orb contact-bg-orb--glow" />

        <div className="container">
          <div className={`row ${homePage ? "justify-content-center" : ""}`}>
            <div
              className={homePage ? "col-lg-8 col-xl-8" : "col-lg-6 col-xl-6"}
            >
              <div className="contact-form contact-form--themed title special">
                <span>Devis gratuit</span>
                <h1>Parlons de votre projet</h1>
                <p className="contact-form__subtitle">
                  Remplissez le formulaire et recevez une estimation sous 24h.
                </p>
                <form
                  onSubmit={(e) => e.preventDefault()}
                  action="#"
                  method="post"
                >
                  <div className="row">
                    <div className="col-12">
                      <input
                        type="text"
                        name="name"
                        placeholder="Nom / Prénom"
                      />
                    </div>
                    <div className="col-xl-6">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email professionnel"
                      />
                    </div>
                    <div className="col-xl-6">
                      <input
                        type="text"
                        name="subject"
                        placeholder="Site web / App / Design ?"
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        name="message"
                        cols={30}
                        rows={10}
                        placeholder="Dites-nous votre projet (budget, délai, besoins...)"
                      />
                    </div>
                    <div className="col-12">
                      <input type="submit" defaultValue="Devis sous 24h →" />
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {!homePage && (
              <div className="col-lg-6 col-xl-6">
                <div className="google-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3323.811476809402!2d-7.6015591243034955!3d33.584243773336944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDM1JzAzLjMiTiA3wrAzNSc1Ni4zIlc!5e0!3m2!1sfr!2sma!4v1774243459430!5m2!1sfr!2sma"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    title="ABEOS Casablanca - Agence digitale"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;
 